import React, { useEffect, useState } from 'react';
import CreateUser from "./organization-create";
import DataTable from 'react-data-table-component';
import { get } from "../../utils/fetchAPI";
import { FaSearch } from "react-icons/fa";
import { BsBuildingCheck } from "react-icons/bs";
import { AnimatePresence, motion } from "framer-motion";
import PageTitle from "../../components/page-title/pageTitle";
import {useNavigate, useSearchParams} from "react-router-dom";
import Loader from "../../components/loader/loder";
import CustomPagination from "../../components/pagination/CustomPagination";


const OrganizationTable = () => {
    const [organization, setOrganization] = useState([]);
    const [searchTerm, setSearchTerm] = useState([]);
    const [filterOrganization, setFilterOrganization] = useState([])
    const [showPopup, setShowPopup] = useState(false);
    const [selectedOrganization, setSelectedOrganization] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const [currentPage, setCurrentPage] = useState(() => {
        return parseInt(searchParams.get("page")) || 1;  // URL থেকে page number পড়বে
    });
    const [perPage, setPerPage] = useState(10);
    const [totalRows, setTotalRows] = useState(0);

    const navigate = useNavigate();

    useEffect(() => {
        navigate(`/organization-list?page=${currentPage}`);
    }, [currentPage, navigate]);

    const fetchUsers = async () => {
        setIsLoading(true);
        await get(`organization/list?per_page=${perPage}&current_page=${currentPage}&search=${searchTerm}`)
            .then((response) => {
                setOrganization(response?.data?.organizations);
                setFilterOrganization(response?.data?.organizations);
                console.log(filterOrganization);
                setTotalRows(response.data?.total);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            }).finally(() => {
                setIsLoading(false);
            });
    };
    useEffect(() => {
        fetchUsers();
    }, [currentPage, perPage, searchTerm]);

    const handleCreateUser = (newOrganization) => {
        if (selectedOrganization) {
            setOrganization(organization.map(organization => (organization._id === newOrganization._id ? newOrganization : organization)));
        } else {
            setOrganization([newOrganization, ...organization]);
        }
        setShowPopup(false);
    };

    const handleEditOrganization = (organization) => {
        setSelectedOrganization(organization);
        setShowPopup(true);
    };

    const location = (organization) => {
        navigate(`/location-detail/${organization._id}`,
            { state: { organization, fromPage: currentPage } });
    };

    const columns = [
        { name: 'Name', selector: row => row?.name, sortable: true },
        { name: 'Description', selector: row => row?.description, sortable: true },
        {
            name: 'Contact Details',
            selector: row => (
                <div className="flex flex-col py-2">
                    {row.contact?.map((contactInfo) => (
                        <div key={contactInfo._id}>
                            <strong>{contactInfo.purpose}:</strong>
                            <ul>
                                {contactInfo.contact.map((c) => (
                                    <li key={c._id}>
                                        {c.system}: {c.value}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            ),
            sortable: false,
        },
        {
            name: 'Status',
            selector: row => (
                <div className="flex items-center gap-2 w-fit">
                    <span
                        className={`w-3 h-3 rounded-full ${
                            row?.status === 'active' ? 'bg-green-500' : 'bg-red-500'
                        }`}
                    ></span>
                    <span className="text-sm font-semibold">
                {row?.status === 'active' ? 'Active' : 'Inactive'}
            </span>
                </div>
            ),
            sortable: true,
        },
        {
            name: 'Actions',
            selector: row => (
                <div className="flex justify-end gap-2 w-fit">
                    <button
                        className="px-2 py-1 bg-secondary text-white rounded"
                        onClick={() => handleEditOrganization(row)}
                    >
                        Edit
                    </button>
                    <button
                        className="px-2 py-1 bg-primary text-white rounded"
                        onClick={() => location(row)}
                    >
                        Location
                    </button>
                </div>
            ),
        }
    ];

    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#50b6b5',
                color: 'white',
                fontSize: '1rem',
                fontWeight: 'bold',
            },
        },
        rows: {
            style: {
                fontSize: '0.9rem',
            },
            stripedStyle: {
                backgroundColor: '#f6f6f6', // Light ash for striped rows
            },
        },
    };

    return (
        <div className='flex justify-center flex-col gap-5 w-full'>
            <div className='flex justify-between items-center'>
                <PageTitle icon={<BsBuildingCheck />} title="Organization List" />
                <div className='flex gap-4'>
                    {/* Search Bar */}
                    <div className="flex items-center border-2 rounded-md w-80">
                        <span className="flex items-center justify-center rounded-bl rounded-tl px-2 text-zinc-500 bg-teal-800 h-full">
                            <FaSearch className="text-white" />
                        </span>
                        <input
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Search by organization name"
                            className="text-sm px-2 py-2 text-black rounded-md w-full placeholder-gray-500 focus:outline-teal-800"
                        />
                    </div>
                    <button
                        onClick={() => {
                            setSelectedOrganization(null);
                            setShowPopup(true);
                        }}
                        className="text-sm px-4 py-2 bg-primary text-white rounded-md"
                    >
                        Create Organization
                    </button>
                </div>
            </div>

            {isLoading ? (
                <div className="text-center text-gray-500"><Loader /></div>
            ) : (
                <DataTable
                    columns={columns}
                    data={filterOrganization}
                    customStyles={customStyles}
                    striped
                    highlightOnHover
                />
            )}

            <CustomPagination
                currentPage={currentPage}
                totalRows={totalRows}
                perPage={perPage}
                setCurrentPage={setCurrentPage}
                setPerPage={setPerPage}
            />

            <AnimatePresence>
                {showPopup && (
                    <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex items-center justify-center">
                        <motion.div initial={{ scale: 0, opacity: 0 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    exit={{ opacity: 0 }}
                                    className="bg-white p-5 rounded-md shadow-lg">
                            <CreateUser
                                organization={selectedOrganization}
                                onCreateUser={handleCreateUser}
                                fetchUsers={fetchUsers}
                                onClose={() => setShowPopup(false)}
                            />
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default OrganizationTable;
